import React,{useEffect,useState} from 'react'
import KPIHeader from '../../Header/KPIHeader';
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
// import MilestoneSubHeader from '../../Header/SubHeader/MilestoneSubHeader';
import ProjectMilestone from '../../Milestone_Inside_Pages/ProjectMilestone';
import MilestoneTracker from '../../Milestone_Inside_Pages/MilestoneTracker';
import MilestoneSummaryTable from '../../Milestone_Inside_Pages/MilestoneSummaryTable';
import MilestoneDefinitions from '../../Defintions/MilestoneDefinitions';
import ProjectOverall from '../../Milestone_Inside_Pages/ProjectOverall';

const MilestoneSummary = () => {
  const email=useSelector((state)=>state.user.email)
  const projectName = useSelector((state) => state.user.projectName);
  const pid=useSelector((state) => state.user.projectId);

     const [executionDate, setExecutionDate] = useState(null);
      const [isLoading, setIsLoading] = useState(true);
      const [error, setError] = useState(null);
  
      useEffect(() => {
                const fetchData = async () => {
                    try {
                        setIsLoading(true);
                        const response = await fetch('https://api-project360-insights.haqdarshak.com/api/last-execution-date/');
                        
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        
                        const data = await response.json();
                        setExecutionDate(data.last_execution_date);
                    } catch (err) {
                        setError(err.message);
                        console.error('Failed to fetch execution date:', err);
                    } finally {
                        setIsLoading(false);
                    }
                };
        
                fetchData();
            }, []);
  
      const formatDate = (dateString) => {
          if (!dateString) return null;
          
          try {
              const date = new Date(dateString.replace(' AM', ''));
              return date.toLocaleString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                  hour12: true
              });
          } catch (e) {
              return dateString;
          }
      };
  

  useEffect(()=>{
    if (!email) {
        return <Navigate to="/" replace />;
      }
      },[])



  return (
      <div>
      <KPIHeader/>
      {/* <MilestoneSubHeader/> */}
    <div class="mt-[8vh]">
         {/* Project Title Section */}
            <div className="px-6 py-2 flex items-center justify-between border-b border-gray-200 mb-3 bg-white rounded-lg shadow-sm">
              <div className="flex items-center space-x-4">
                <div className="bg-blue-100 p-2 rounded-lg">
                  <svg 
                    className="w-6 h-6 text-blue-600" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24" 
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" 
                    />
                  </svg>
                </div>
                <h1 className="text-2xl font-bold text-gray-800 truncate max-w-xs md:max-w-md">
                  {projectName}
                </h1>
              </div>
              <span><MilestoneDefinitions/></span>
              <div className="flex items-center text-sm text-black">
                    {isLoading ? (
                        <div className="flex items-center">
                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-gray-400 mr-1"></div>
                            <span>Loading update...</span>
                        </div>
                    ) : error ? (
                        <div className="flex items-center text-red-500">
                            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>Update failed</span>
                        </div>
                    ) : (
                        <div className="flex items-center">
                            <svg className="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span> Data Last Updated At: {formatDate(executionDate)}</span>
                        </div>
                    )}
                </div>
              
              <span className="bg-gradient-to-r from-purple-100 to-indigo-100 text-purple-800 text-sm font-semibold px-4 py-2 rounded-full shadow-sm flex items-center">
                <svg
                  className="w-4 h-4 mr-2" 
                  fill="currentColor" 
                  viewBox="0 0 20 20" 
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" 
                    clipRule="evenodd" 
                  />
                </svg>
                PID: {pid}
              </span>
            </div>
            <MilestoneTracker/>
            <ProjectOverall/>
            <MilestoneSummaryTable/>
        <ProjectMilestone/>
     </div>
    </div>
  )
}

export default MilestoneSummary
